<template>
  <main class="main-content">
    <!--Event Section-->
    <!--Added eventsHead from previous Version-->
    <section class='gradient-faded'>
      <div class="container pt90 pb90">
        <h3 class="text-center section-title mb70">The Puppy Lounge Does Events:
          <br>
          We don't really do much events, but if we come up with something we will try to let you know.</h3>
        <div class="row">
          <div class="col-lg-4 border border-faded border-top-0 border-left-0 feature-icon text-center">
            <h4>Monday</h4>
            <!--Added eventsBody from previous Version-->
            <p>
              On Monday's we tend to play our weekly Discover playlist that Spotify made for us. Usually, this list
              will consist of
              songs that we haven't listened to on Spotify, it could be new or old stuff.</p>
          </div>
          <div class="col-lg-4 feature-icon border border-faded border-left-0 border-top-0 text-center">
            <h4>Tuesday</h4>
            <!--Added eventsBody from previous Version-->
            <p>
              Tuesdays are made to be free for all. Go with the flow of the room!
            </p>
          </div>
          <div class="col-lg-4 feature-icon border border-faded border-left-0 border-top-0 border-right-0 text-center">
            <h4>Wednesday</h4>
            <!--Added eventsBody from previous Version-->
            <p>
              Wednesday's are made to be free for all. Go with the flow of the room!
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4 feature-icon border border-faded border-left-0 border-top-0 border-bottom-0 text-center">
            <h4>Thursday</h4>
            <!--Added eventsBody from previous Version-->
            <p>
              On Thursday's we like to pepper in some throwbacks jams and scour the nets for new releases!
            </p>
          </div>
          <div class="col-lg-4 feature-icon border border-faded border-top-0 border-left-0 border-bottom-0 text-center">
            <h4>Friday</h4>
            <!--Added eventsBody from previous Version-->
            <p>
              Fridays are Fresh, this day we try our best to play the newest of the new tunes, with the help of our
              Release Radar
              playlists, Fresh Finds playlist, and much more. Jump on and play some fresh tunes!
            </p>
          </div>
          <div
            class="col-lg-4 mb40 feature-icon border border-faded border-bottom-0 border-top-0 border-left-0 border-right-0 text-center">
            <h4>Sunday</h4>
            <!--Added eventsBody from previous Version-->
            <p>
              On Sundays, we promote the adoption of homeless pets.
            </p>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: 'events-section',
  props: {},
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss">

</style>
